import { TableCell, TableRow } from "@mui/material";

import { BasketStack } from "../types";
import { CraneTableCell } from "./cell/CraneTableCell";

interface CraneTableRowProps {
  position: number;
  stacks: BasketStack[];
}

export const CraneTableRow = ({ position, stacks }: CraneTableRowProps) => {
  return (
    <TableRow hover>
      <TableCell
        align="center"
        sx={{
          position: "sticky",
          left: 0,
          backgroundColor: "background.paper",
          fontSize: { xs: 18, md: 24, lg: 32 },
          minWidth: { xs: 56, md: 72, lg: 96 },
          maxWidth: 120,
          color: "text.secondary",
        }}
      >
        {position + 1}
      </TableCell>
      {stacks.map(({ basket, layers }) => {
        const layer = layers[position];

        if (!layer) {
          return (
            <TableCell
              key={`empty-${basket.load_basket_id}`}
              sx={{
                minWidth: { xs: 280, md: 350, lg: 420 },
                maxWidth: { lg: 500 },
              }}
            />
          );
        }

        return (
          <CraneTableCell
            key={basket.load_basket_id}
            basket={basket}
            layer={layer}
          />
        );
      })}
    </TableRow>
  );
};
